<div id="map" #map #mapContainer (window:resize)="onResize($event)"></div>
